import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { grupoService } from '../lib/supabase'
import toast from 'react-hot-toast'

export default function GruposPage() {
  const { user, profile, signOut } = useAuth()
  const navigate = useNavigate()
  const [grupos, setGrupos] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null) // 'criar' | 'entrar'
  const [form, setForm] = useState({ nome: '', descricao: '', codigo: '', tipo: 'banda' })
  const [saving, setSaving] = useState(false)

  useEffect(() => { carregarGrupos() }, [user])

  async function carregarGrupos() {
    if (!user) return
    try {
      const data = await grupoService.meuGrupos(user.id, 'cifrasband')
      setGrupos(data)
    } catch (e) {
      toast.error('Erro ao carregar grupos')
    } finally {
      setLoading(false)
    }
  }

  async function criarGrupo() {
    if (!form.nome.trim()) { toast.error('Digite o nome do grupo'); return }
    setSaving(true)
    try {
      const grupo = await grupoService.criarGrupo({ nome: form.nome, descricao: form.descricao, tipo: form.tipo, modulo: 'cifrasband' }, user.id)
      toast.success(`Grupo "${grupo.nome}" criado!`)
      setModal(null)
      setForm({ nome: '', descricao: '', codigo: '' })
      navigate(`/grupo/${grupo.id}`)
    } catch (e) {
      toast.error(e.message)
    } finally {
      setSaving(false)
    }
  }

  async function entrarGrupo() {
    if (!form.codigo.trim()) { toast.error('Digite o código de convite'); return }
    setSaving(true)
    try {
      const grupo = await grupoService.entrarPorCodigo(form.codigo.trim())
      toast.success(`Entrou no grupo "${grupo.nome}"!`)
      setModal(null)
      navigate(`/grupo/${grupo.id}`)
    } catch (e) {
      toast.error(e.message || 'Código inválido')
    } finally {
      setSaving(false)
    }
  }

  const iniciais = (nome) => nome?.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase() || '?'
  const coresAv = ['av-red', 'av-gold', 'av-green', 'av-blue']

  return (
    <div className="app-container">
      {/* Header */}
      <div style={{ padding: '20px 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/logo-app.png" alt="CifrasBand" style={{ width: 38, height: 38, objectFit: 'contain' }} />
          <div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 800, letterSpacing: 0.5 }}>
              <span style={{ color: '#00CFFF' }}>CIFRAS</span><span style={{ color: '#FF8C00' }}>BAND</span>
            </div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 1 }}>
              Olá, {profile?.nome?.split(' ')[0] || 'músico'} 👋
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={() => navigate('/perfil')}
            style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid var(--card-border)', borderRadius: 10, padding: '6px 12px', cursor: 'pointer', fontSize: 18 }}
            title="Meu perfil">
            {profile?.avatar_url
              ? <img src={profile.avatar_url} alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', verticalAlign: 'middle' }} />
              : '👤'}
          </button>
          <button onClick={() => navigate('/planos')} className="btn btn-sm" style={{ fontSize: 11, borderColor: 'rgba(255,140,0,0.4)', color: 'var(--gold)' }}>⚡ Planos</button>
          {user?.email === 'andersonmelies@gmail.com' && (
            <button onClick={() => navigate('/admin')} className="btn btn-sm" style={{ fontSize: 11, borderColor: 'rgba(0,207,255,0.4)', color: '#00CFFF' }} title="Painel Admin">⚙️</button>
          )}
          <button onClick={signOut} className="btn btn-sm" style={{ fontSize: 11 }}>Sair</button>
        </div>
      </div>

      <div style={{ flex: 1, padding: '24px 20px' }}>
        <div className="section-hdr">
          <div className="section-title">Meus Grupos</div>
        </div>

        {/* Botões de ação */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
          <button className="btn btn-primary" onClick={() => setModal('criar')}>
            + Criar grupo
          </button>
          <button className="btn" onClick={() => setModal('entrar')}>
            🔑 Entrar com código
          </button>
        </div>

        {/* Acesso ao módulo Classic */}
        <button onClick={() => navigate('/classic')}
          style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1px solid rgba(255,140,0,0.3)', background: 'rgba(255,140,0,0.06)', color: 'var(--gold)', fontSize: 13, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24, fontFamily: 'Montserrat,sans-serif' }}>
          <span style={{ fontSize: 20 }}>🎼</span>
          <div style={{ flex: 1, textAlign: 'left' }}>
            <div>CifrasBand Classic</div>
            <div style={{ fontSize: 11, fontWeight: 400, color: 'rgba(255,140,0,0.6)', marginTop: 1 }}>Orquestras e grupos com partituras</div>
          </div>
          <span style={{ opacity: 0.5 }}>›</span>
        </button>

        {/* Lista de grupos */}
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
            <div className="spinner" />
          </div>
        ) : grupos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🎵</div>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Nenhum grupo ainda</div>
            <div style={{ fontSize: 14, color: 'var(--muted)' }}>
              Crie um grupo ou entre com um código de convite
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {grupos.map((g, i) => (
              <div key={g.id} className="card" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 14 }}
                onClick={() => navigate(`/grupo/${g.id}`)}>
                <div className={`avatar av-md ${coresAv[i % 4]}`} style={{ fontSize: 18 }}>
                  {iniciais(g.nome)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{g.nome}</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                    {g.descricao || 'Grupo de músicos'} • {g.meu_papel === 'admin' ? '👑 Admin' : 'Membro'}
                  </div>
                </div>
                <div style={{ fontSize: 12, color: '#00CFFF', fontFamily: 'Montserrat, monospace', background: 'rgba(0,207,255,0.08)', border: '1px solid rgba(0,207,255,0.2)', padding: '4px 10px', borderRadius: 8, fontWeight: 700, letterSpacing: 1 }}>
                  {(() => { const c = (g.codigo_convite||'').toUpperCase(); return c.length===8?`${c.slice(0,4)}-${c.slice(4)}`:c.length===6?`${c.slice(0,3)}-${c.slice(3)}`:c })()}
                </div>
                <div style={{ color: 'var(--muted)' }}>›</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal Criar */}
      {modal === 'criar' && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" onClick={() => setModal(null)} />
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
              Criar novo grupo
            </div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 14 }}>
              Um código de convite será gerado automaticamente
            </div>

            {/* Tipo do grupo */}
            <div style={{ display: 'flex', background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 4, marginBottom: 16, gap: 4 }}>
              {[
                { id: 'banda',      label: '🎸 Banda / Louvor',  desc: 'Cifras e acordes' },
                { id: 'orquestra',  label: '🎼 Orquestra',       desc: 'Partituras e PDFs' },
                { id: 'ambos',      label: '🎵 Ambos',           desc: 'Cifras + Partituras' },
              ].map(op => (
                <button key={op.id} onClick={() => setForm(f => ({ ...f, tipo: op.id }))}
                  style={{ flex: 1, padding: '9px 4px', borderRadius: 9, border: 'none', cursor: 'pointer', transition: 'all 0.2s',
                    background: form.tipo === op.id ? 'var(--brand2)' : 'transparent',
                    color: form.tipo === op.id ? '#fff' : 'rgba(255,255,255,0.45)',
                    fontFamily: 'Montserrat,sans-serif', fontSize: 11, fontWeight: 700 }}>
                  <div>{op.label}</div>
                  <div style={{ fontSize: 9, fontWeight: 400, opacity: 0.8, marginTop: 1 }}>{op.desc}</div>
                </button>
              ))}
            </div>

            <div className="input-group">
              <label className="input-label">Nome do grupo</label>
              <input className="input" placeholder="Ex: Banda do Caio, Coral da Igreja..." value={form.nome}
                onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} autoFocus />
            </div>
            <div className="input-group" style={{ marginBottom: 20 }}>
              <label className="input-label">Descrição (opcional)</label>
              <input className="input" placeholder="Ex: Grupo de louvor da comunidade" value={form.descricao}
                onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} />
            </div>
            <button className="btn btn-primary btn-block" onClick={criarGrupo} disabled={saving}
              style={{ height: 52, fontSize: 15, fontWeight: 700 }}>
              {saving ? <span className="spinner" /> : form.tipo === 'orquestra' ? '🎼 Criar grupo' : '🎸 Criar grupo'}
            </button>
          </div>
        </div>
      )}

      {/* Modal Entrar */}
      {modal === 'entrar' && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" onClick={() => setModal(null)} />
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
              Entrar em um grupo
            </div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20 }}>
              Peça o código de convite para o admin do grupo
            </div>
            <div className="input-group" style={{ marginBottom: 20 }}>
              <label className="input-label">Código de convite</label>
              <input className="input" placeholder="Ex: a3f7b2c1" value={form.codigo}
                onChange={e => setForm(f => ({ ...f, codigo: e.target.value }))}
                autoFocus style={{ textTransform: 'lowercase', letterSpacing: 2, fontFamily: 'monospace' }} />
            </div>
            <button className="btn btn-primary btn-block" onClick={entrarGrupo} disabled={saving}
              style={{ height: 52, fontSize: 15, fontWeight: 700 }}>
              {saving ? <span className="spinner" /> : '🔑 Entrar no grupo'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
